export default {
    state: {
        received_id: null,
        received: [],
        errors: {},
        meta: {
            order_id: null,
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },

        table: {
            fields: [
                {key: 'id', label: 'code', sortable: true},
                {key: 'date', label: 'Date', sortable: true},
                {key: 'request_code', label: 'Request Code', tdClass: 'text-muted'},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'store', label: 'Store', tdClass: 'text-muted'},
                {key: 'shelf', label: 'Shelf', tdClass: 'text-muted'},
                {key: 'item', label: 'Item', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        form: {
            code: '',
            date: null,
            request_code: '',
            facility_id: '',
            store_id: '',
            item_id: '',
            shelf_id: '',
            notes: '',
        },
    },

    getters: {
        getReceivedMeta: state => state.meta,

        getReceivedTableFields: state => state.table.fields,

        getReceivedItemForm: state => state.form,

        getReceivedItemErrors: state => state.errors,
    },

    mutations: {
        resetReceivedMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setReceivedItems: (state, payload) => {
            state.received = payload;
        },

        setReceivedItemsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setReceivedItemsForm: state => {
            state.form = {
                code: '',
                date: null,
                request_code: '',
                requested_by: '',
                supplier_id: '',
                facility_id: '',
                store_id: '',
                item_id: '',
                tax: '',
                dsicount: '',
                payment_term: '',
                notes: '',
            };

            state.errors = {};
        },

        setOrderErrors: (state, payload) => {
            state.errors = payload;
        },
    },

    actions: {
        fetchReceivedItems: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const received = {
                "data": [
                    {
                        "received_id": 1,
                        "label": "ReceivedItem1",
                        "data": {
                            "type": "ReceivedItem",
                            "attributes": {
                                "code": "PRU000001",
                                "request_code": "REQ000001",
                                "date": "12-12-12",
                                "type": "damage",
                                "facility": "NB-001 - Cedar Harbor Residence [V-IR] [I-DR]",
                                "store": "1",
                                "shelf": "4-H",
                                "item": "i-phone",
                            }
                        },
                        "links": {"self": "received\/1"}
                    },
                    {
                        "received_id": 2,
                        "label": "ReceivedItem2",
                        "data": {
                            "type": "ReceivedItem",
                            "attributes": {
                                "code": "PRU000002",
                                "request_code": "REQ000002",
                                "date": "17-02-11",
                                "type": "received",
                                "facility": "NB-002 - Meridian House [V-IR] [I-DR]",
                                "store": "u W u",
                                "shelf": "3-S",
                                "item": "him-phone",
                            }
                        },
                        "links": {"self": "received\/2"}
                    },
                    {
                        "received_id": 3,
                        "label": "ReceivedItem3",
                        "data": {
                            "type": "ReceivedItem",
                            "attributes": {
                                "code": "PRU000003",
                                "request_code": "REQ000002",
                                "date": "26-12-12",
                                "type": "expired",
                                "facility": "NB-002 - Meridian House [V-IR] [I-DR]",
                                "store": "1",
                                "shelf": "9-B",
                                "item": "nokia-3310",
                            }
                        },
                        "links": {"self": "received\/3"}
                    },
                ],
                "links": {
                    "self": "\/received",
                    "first": "http:\/\/pilot.test\/api\/inventory\/receiveds\/received?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/receiveds\/received?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/receiveds\/received?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/receiveds\/received",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setReceivedItems', received);

                commit('setReceivedItemsMeta', received.meta);

                resolve(received);
            });
        },

        fetchEditReceivedItems: ({state, commit}, order_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + order_id + '/edit')
                    .then(response => {
                        state.received_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitReceivedItem: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setReceivedItemsErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateReceivedItem: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.received_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setReceivedItemsErrors', error.response.data.errors);

                        reject();
                    });
            })
        },
    }
}
